import React from "react";
import ViewWorkspaces from "../Components/Workspace/ViewAllWorkspaces";

const ViewAllWorkspacesPage = () => {
  return <ViewWorkspaces />;
};

export default ViewAllWorkspacesPage;
